export const formatTimeRange = (startTime: string, endTime: string): string => {
  return `${startTime} - ${endTime}`;
};

export const calculateDuration = (startTime: string, endTime: string): string => {
  const [startHour, startMin] = startTime.split(":").map(Number);
  const [endHour, endMin] = endTime.split(":").map(Number);
  const durationMinutes = endHour * 60 + endMin - (startHour * 60 + startMin);

  if (durationMinutes === 60) return "1 godz";
  if (durationMinutes < 60) return `${durationMinutes} min`;

  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;

  if (minutes === 0) {
    return hours === 1 ? "1 godz" : `${hours} godz`;
  }

  const hoursText = hours === 1 ? "1 godz" : `${hours} godz`;
  return `${hoursText} ${minutes} min`;
};

export const isTimeSlotPast = (startTime: string): boolean => {
  const now = new Date();
  const currentTime = now.getHours() * 60 + now.getMinutes();
  const [hours, minutes] = startTime.split(":").map(Number);
  return hours * 60 + minutes < currentTime;
};

export const getStatusText = (status: string): string => {
  const statusMap: Record<string, string> = {
    available: "Dostępne",
    unavailable: "Niedostępne",
    assigned: "Jesteś zapisany",
    "sold-out": "Wyprzedane",
    "in-basket": "W koszyku",
  };

  return statusMap[status] || status;
};
